import React, { Component } from 'react';

import './Contact.css';
import mailIcon from '../../icons/ic_mail.svg';
import twitterIcon from '../../icons/ic_twitter.svg';
import githubIcon from '../../icons/ic_github.svg';
import userReportIcon from '../../icons/ic_user_report.svg';
import { trackHostClick } from '../../utils';

class Contact extends Component {
  render() {
    return (
      <div className="lp-mobile-contact-container">
        <div className="lp-social-media">
          <a href="https://www.gmail.com" target="_blank" rel="noopener noreferrer" onClick={e => {
            trackHostClick(e, 'a social media icon from the mobile contact footer');
          }}>
            <div>
              <img src={mailIcon} alt="Email Us Icon"/>
              <label>Email Us</label>
            </div>
          </a>
          <a href="https://twitter.com/improveosm" target="_blank" rel="noopener noreferrer" onClick={e => {
            trackHostClick(e, 'a social media icon from the mobile contact footer');
          }}>
            <div>
              <img src={twitterIcon} alt="Twitter Icon"/>
              <label>Twitter</label>
            </div>
          </a>
          <a href="https://github.com/improveOSM" target="_blank" rel="noopener noreferrer" onClick={e => {
            trackHostClick(e, 'a social media icon from the mobile contact footer');
          }}>
            <div>
              <img src={githubIcon} alt="Github Icon"/>
              <label>Github</label>
            </div>
          </a>
		  <a href="https://github.com/ImproveOSM/improve-osm-plugin/issues" target="_blank" rel="noopener noreferrer" onClick={e => {
            trackHostClick(e, 'a social media icon from the mobile contact footer');
          }}>
            <div>
              <img src={userReportIcon} alt="User Report Icon"/>
              <label>Improve OSM</label>
            </div>
          </a>
		  <a href="https://github.com/kartaview/josm-plugin/issues" target="_blank" rel="noopener noreferrer" onClick={e => {
            trackHostClick(e, 'a social media icon from the mobile contact footer');
          }}>
            <div>
              <img src={userReportIcon} alt="User Report Icon"/>
              <label>KartaView</label>
            </div>
          </a>
        </div>
        <div className="lp-copyright">
          Copyright © 2024 Grab <br/>All rights reserved.
        </div>
        <div className="lp-legal">
          <a href="https://kartaview.org/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a><br />
          <a href="https://kartaview.org/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/mobile/Contact.js